export const SET_EMAILED_DASHBOARDS_LOADED = "SET_EMAILED_DASHBOARDS_LOADED";

export const setEmailDashboardLoaded = (loadingEmailedPbiDashboard: boolean) => {
    return {
        loadingEmailedPbiDashboard,
        type: SET_EMAILED_DASHBOARDS_LOADED
    };
};
